<template>
    <section>
        <div class="page-wrap">
            <div class="container product">
                <div class="box-content">
                    <div class="row">
                        <template v-if="isGc">
                            <div class="col-md-7">
                                <div class="prod-container">
                                    <img class="prod-img" src="images/giftcertificate600.png" alt="">
                                </div>
                            </div>
                            <div class="col-md-5">
                                <h3>GIFT CERTIFICATE</h3>
                                <hr>
                                <div class="brick-text-form">
                                    <label class="text-lg" for="line1">Select your brick option:</label>
                                    <br/>
                                    <select class="form-control" v-model="item_id" v-on:change="onProductChange(item_id)">
                                        <option value="0">-- Please select an item --</option>
                                        <option v-for="(prod, prodIndex) in products" v-bind:value="prodIndex">
                                            <span v-html="prod.description"></span> - ${{prod.price}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="col-md-7">
                                <div class="prod-container">
                                    <img class="prod-img" v-bind:src="'images/catalog/' + campaign.short_url + '/' + product.item_image_blank"/>
                                    <div class="prod-replica">
                                        <div class="prod-replica-table">
                                            <div class="prod-replica-table-td vb">
                                                <p v-for="n in product.max_lines">{{ lines[n-1] }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <h3 v-html="product.description"></h3>
                                <h4>$&nbsp;{{ product.price }}</h4>
                                <hr/>
                                <h3>
                                    <a class="text-danger underline pointer"
                                        v-on:click="showInscriptionGuidelines()"
                                    >Inscription Guidelines</a>*
                                </h3>
                                <div class="brick-text-form">
                                    <div v-for="n in product.max_lines" class="form-group row no-gutter">
                                        <div class="col-md-2">
                                            <label v-bind:for="'l-' + n">Line {{ n }}:</label>
                                        </div>
                                        <div class="col-md-10">
                                            <greek-letters-dropdown v-bind:line-id="'l-' + n">
                                                <input class="form-control"
                                                    v-on:keydown="withAnyKeyDown($event)"
                                                    v-on:keyup="withAnyKeyUp($event)"
                                                    v-on:input="withInput($event)"
                                                    v-bind:id="'l-' + n"
                                                    v-bind:value="lines[n-1]"
                                                    v-bind:maxlength="product.max_characters"
                                                    v-bind:size="product.max_characters"
                                                />
                                            </greek-letters-dropdown>
                                        </div>
                                    </div>
                                </div>
                                <p>Need inspiration?
                                    <a class="text-danger pointer" v-on:click="showInscriptionExamples()">Click here</a>
                                    for inscription examples.
                                </p>
                            </div>
                        </template>
                    </div>
                    <div v-if="!isGc" class="row">
                        <div class="col-md-12">
                            <p>
                                <span class="text-danger">*</span>
                                D.C. United reserve the right to approve all brick inscriptions. Inscriptions that do not conform to the provided inscription guidelines will be declined and will require a new inscription to be submitted.
                            </p>
                        </div>
                    </div>
                    <preferred-location v-if="!isGc && isLocationPreferenceAllowed"
                        v-bind:options="product.options || {}"
                        v-bind:location="location"
                        on-location-change="onProductLocationChange"
                    ></preferred-location>
                    <template v-if="!isGc || item_id > 0">
                        <hr/>
                        <h3>ADDITIONAL ITEMS</h3>
                        <p>Would you like to add additional keepsake items to your order? All orders include one (1) complimentary replica.</p>
                        <br/>
                        <div class="row">
                            <div class="col-sm-4 text-center" v-for="(child, childIndex) in baseProductChildren">
                                <div class="img-box">
                                    <div class="img-wrap">
                                        <div class="prod-container">
                                            <img class="prod-img" v-bind:src="
                                                'images/catalog/' + campaign.short_url + '/' +
                                                    (isGc ? child.item_image_default : child.item_image_blank)"
                                            />
                                            <div v-if="child.item_type == 2 && !isGc" class="prod-replica">
                                                <div class="prod-replica-table">
                                                    <div class="prod-replica-table-td vb">
                                                        <p v-for="n in product.max_lines">{{ lines[n-1] }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <p class="product-title text-left">
                                    <span v-html="child.description"></span>
                                </p>
                                <div class="row wrap-count">
                                    <div class="col-xs-6 text-left">${{child.price}}</div>
                                    <div class="col-xs-6 text-right">
                                        <div class="amount no-select">
                                            <span v-on:click="sub1(child.item_id)" class="pointer">-</span>
                                            <span>{{ qtys[child.item_id] }}</span>
                                            <span v-on:click="add1(child.item_id)" class="pointer">+</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="btn-wrap">
                                <a class="btn btn-danger btn-lg pull-right"
                                    v-bind:disabled="item_id == 0"
                                    v-on:click="addToCart"
                                >Add to cart</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script type="text/jsx">
    import Vue from 'vue'
    import { Event } from '../../../../../assets/js/components/frontend/event.vue'
    import store from '../../store'
    import CampaignConfigurationMixin from '../../../../../assets/js/components/frontend/mixin/campaign-configuration.vue'
    import InscriptionEditMixin from '../../../../../assets/js/components/frontend/mixin/inscription-edit.vue'
    import InscriptionHandlingMixin from '../mixin/inscription-handling.vue'
    import GreekLettersDropdown from '../elements/greek-letters-dropdown.vue'
    import PreferredLocation from '../elements/preferred-location.vue'
    export default {
        name: 'product',
        mixins: [
            CampaignConfigurationMixin,
            InscriptionEditMixin,
            InscriptionHandlingMixin
        ],
        components: {
            'greek-letters-dropdown': GreekLettersDropdown,
            'preferred-location': PreferredLocation
        },
        data: function () {
            return this.getDefaultData();
        },
        props: {
            isLowerCaseAllowed: { // to override default value in InscriptionEditMixin
                type: String,
                default: () => 'no'
            }
        },
        beforeRouteEnter(to, from, next) {
            let productId = to.params.id || '';
            if (productId === 'gc' || productId in store.getters.products) {
                next();
            } else {
                next({name: 'Shop'});
            }
        },
        created: function () {
            Event.$on('onProductLocationChange', this.onLocationChange);
        },
        beforeDestroy: function () {
            Event.$off('onProductLocationChange', this.onLocationChange);
        },
        methods: {
            getDefaultData: function () {
                return {
                    item_id: 0, // zero for a GC
                    location: '', // preferred
                    qtys: {}, // item_id => qty
                    lines: {
                        // index: text
                    }
                }
            },
            showInscriptionGuidelines: function () {
                Event.$emit('inscriptionGuidelinesPopup');
            },
            showInscriptionExamples: function () {
                Event.$emit('inscriptionExamplesPopup');
            },
            showPaverLocations: function () {
                Event.$emit('paverLocationsPopup');
            },
            addToCart: function () {
                this.$store.commit('addItemToCart', {
                    item_id: this.item_id > 0 ? this.item_id : +this.$route.params.id,
                    temp_id: +new Date(),
                    options: {
                        location: this.location
                    },
                    gc: this.isGc,
                    lines: this.lines,
                    children: this.qtys
                });
                this.$router.push({ path: '/cart'});
            },
            onProductChange: function (id) {
                if (id in this.products) {
                    this.item_id = id;
                }
            },
            onLocationChange: function (newLocation) {
                this.location = newLocation;
            },
            add1: function (itemId) {
                var newValue = (itemId in this.qtys) ? this.qtys[itemId] : 0;
                newValue++;
                Vue.set(this.qtys, itemId, newValue);
            },
            sub1: function (itemId) {
                var newValue = (itemId in this.qtys) ? this.qtys[itemId] : 0;
                if (newValue > 0) {
                    newValue--;
                }
                Vue.set(this.qtys, itemId, newValue);
            }
        },
        computed: {
            campaign: function () {
                return this.$store.state.campaign
            },
            products: function () {
                return this.$store.getters.products
            },
            product: function () {
                var productId = this.$route.params.id
                if (productId in this.$store.getters.products) {
                    this.item_id = productId;
                    return this.$store.getters.products[this.$route.params.id]
                }
                return {};
            },
            isGc: function () {
                return this.$route.params.id == 'gc' ? true :false
            },
            baseProductChildren: function () {
                if (this.item_id in this.products) {
                    var qtys = {};
                    var children = this.products[this.item_id]['children'];
                    for (var key in children) {
                        if ('item_id' in children[key]) {
                            qtys[children[key]['item_id']] = 0;
                        }
                    }
                    this.qtys = Object.assign({}, qtys);
                    return this.products[this.item_id]['children'];
                } else {
                    return [];
                }
            }
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// Product.vue?312d09fa